import { BaseService } from '@/modules/core/app/services/abstracts/BaseService';
import WorkflowEstateStatusResource from '@/modules/workflow/resource/WorkflowEstateStatusListResource';
import { GenericModel } from '@/modules/core/app/models/GenericModel';

export class WorkflowEstateStatusListService extends BaseService {
  resource: typeof WorkflowEstateStatusResource;

  constructor() {
    super();

    this.resource = WorkflowEstateStatusResource;
  }

  getEstateStatusList(
    selectedJurisdictions: Array<number>,
    selectedEstateTypes: Array<string>,
    workflowType?: string
  ): Promise<Array<GenericModel>> {
    return this.resource.getEstateStatusList(selectedJurisdictions, selectedEstateTypes, workflowType);
  }
}

export default new WorkflowEstateStatusListService();
